export function isExternalLink(referrer: string) {
  const url = new URL(referrer);
  return url.host !== window.location.host;
}
